import { Button, Checkbox, FormControlLabel } from '@mui/material';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { Banniere } from '../../../models/Banniere';
import { useGetBannieresQuery } from '../../../redux/features/cache';

export interface IListeMagasinsModalProps {
  selectedMags: Function
  listMags: any
}

export default function ListMagasinsModal({ selectedMags, listMags }: IListeMagasinsModalProps) {
  const { data: bannieres = [] as Banniere[] } = useGetBannieresQuery({ InclMag: true, treeView: false });
  const [data, setData] = useState([] as any[]);

  useEffect(() => {
    let newData = bannieres.map((item) => {
      const newMagasin = item.magasin.map((subItem) => {
        const isChecked = listMags.some((listMag: any) => listMag.mag_num === subItem.mag_num);
        const isDisabled = listMags.some((listMag: any) => listMag.mag_num === subItem.mag_num && listMag.disabled === true);
        return {
          ...subItem,
          isChecked: isChecked,
          disabled: isDisabled,

        };
      });

      const isChecked = newMagasin.some((mag) => mag.isChecked);
      return {
        ...item,
        isChecked: isChecked,
        magasin: newMagasin
      };
    });
    setData(JSON.parse(JSON.stringify(newData)));
  }, [bannieres, listMags]);

  const handleChecked = (e: any, i: number, parent: number) => {
    const newData = [...data]
    newData[parent].magasin[i].isChecked = !newData[parent].magasin[i].isChecked;
    setData(JSON.parse(JSON.stringify(newData)))
  }

  const handleAll = (_event: any, i: number) => {
    const newData = [...data]
    newData[i].isChecked = !newData[i].isChecked
    newData[i].magasin.forEach((e: any) => {
      if (e.isChecked !== newData[i].isChecked && !e.disabled) {
        e.isChecked = !e.isChecked

      }
    })
    setData(JSON.parse(JSON.stringify(newData)))
  }

  const Children = ({ data, parent }: { data: any, parent: number }) => (
    <Box sx={{
      display: 'grid',
      columnGap: '1rem',
      rowGap: '0.5rem',
      gridAutoFlow: 'dense',
      gridTemplateColumns: 'repeat(3, minmax(24%, 1fr))'
    }}>
      {data.map((e: any, i: number) => (
        <FormControlLabel
          key={i}
          label={e.mag_nom_aff}
          control={<Checkbox
            sx={{
              color: '#2f3436',
              '&.Mui-checked': {
                color: '#007bff',
              },
              ml: 2
            }}
            onChange={(e) => handleChecked(e, i, parent)}
            checked={e.isChecked}
            value={e.mag_num}
            disabled={e.disabled}
          />}
        />
      ))}
    </Box>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
        {data.length > 0 &&
          data.map((e, i) => (
            <Box key={i} sx={{ p: 2, m: 1, boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)', width: '35vw', maxWidth: '35vw' }}>
              <FormControlLabel
                sx={{ fontWeight: 'bold', }}
                label={e.maggrp_descr}
                control={
                  <Checkbox
                    sx={{
                      color: '#2f3436',
                      '&.Mui-checked': {
                        color: '#007bff',
                      },
                    }}
                    onChange={(e) => { handleAll(e, i) }}
                    checked={e.isChecked}
                    value={e.maggrp_cd}
                  />
                }
              />
              <Children data={e.magasin} parent={i} />
            </Box>
          )
          )}
      </Box>
      <Button variant='contained' sx={{ m: 1 }} onClick={(e) => { selectedMags(data) }}>Confirmer</Button>
    </Box>
  );
}

